import EmblaCarousel from 'embla-carousel';

const emblaMobileSlider = () => {
  const emblaNodes = document.querySelectorAll(".embla-mobile-slider");

  if (!emblaNodes.length) return;

  const mobileOptions = { 
    loop: false,
    align: 'start',
    containScroll: 'trimSnaps',
    dragThreshold: 5,
    skipSnaps: true,
    slidesToScroll: 1,
    startIndex: 0
  };
  
  const emblaApis = new Map();

  const initOrDestroySlider = (node) => {
    const existingApi = emblaApis.get(node);

    if (existingApi) {
      existingApi.destroy();
      emblaApis.delete(node);
    }

    if (window.innerWidth < 960) {
      const newApi = EmblaCarousel(node.querySelector('.embla__viewport'), mobileOptions);
      emblaApis.set(node, newApi);
    }
  };

  emblaNodes.forEach((node) => {
    initOrDestroySlider(node);
  });

  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      emblaNodes.forEach((node) => {
        initOrDestroySlider(node);
      });
    }, 150);
  });
};

// Fonction pour gérer les boutons prev/next
const addPrevNextButtonClickHandlers = (emblaApi, prevBtn, nextBtn, containerNode) => {
  if (!prevBtn || !nextBtn) return;

  const scrollPrev = () => emblaApi.scrollPrev();
  const scrollNext = () => emblaApi.scrollNext();

  if (window.innerWidth > 768) {
    
    prevBtn.addEventListener('click', scrollPrev, false);
    nextBtn.addEventListener('click', scrollNext, false);
  }

  // Mise à jour de la slide actuelle
  const updateSlideCounter = () => {
    const currentIndex = emblaApi.selectedScrollSnap() + 1;
    
    // Mettre à jour Alpine.js
    const alpineComponent = Alpine.$data(containerNode.closest('[x-data]'));
    if (alpineComponent) {
      alpineComponent.currentSlide = currentIndex;
    }
  };

  emblaApi.on('select', updateSlideCounter);
  emblaApi.on('init', updateSlideCounter);
  emblaApi.on('reInit', updateSlideCounter);
};

const emblaDesktopGallerySlider = () => {
  const emblaNodes = document.querySelectorAll(".embla-desktop-gallery-slider");

  if (!emblaNodes.length) return;

  const sliderOptions = { 
    loop: true,
    align: 'start',
    containScroll: 'trimSnaps',
    dragThreshold: 5,
    skipSnaps: false,
    slidesToScroll: 1,
    startIndex: 0
  };
  
  const emblaApis = new Map();

  const initOrDestroySlider = (node) => {
    const existingApi = emblaApis.get(node);

    if (existingApi) {
      existingApi.destroy();
      emblaApis.delete(node);
    }

    const newApi = EmblaCarousel(node.querySelector('.embla__viewport'), sliderOptions);

    emblaApis.set(node, newApi);
    
    const prevBtnNode = node.querySelector('.embla__button--prev');
    const nextBtnNode = node.querySelector('.embla__button--next');
    addPrevNextButtonClickHandlers(newApi, prevBtnNode, nextBtnNode, node);

  };

  emblaNodes.forEach((node) => {
    initOrDestroySlider(node);
  });

  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      emblaNodes.forEach((node) => {
        initOrDestroySlider(node);
      });
    }, 150);
  });
};

const emblaMobileGallerySlider = () => {
  const emblaNodes = document.querySelectorAll(".embla-mobile-gallery-slider");

  if (!emblaNodes.length) return;

  const sliderOptions = { 
    loop: false,
    align: 'start',
    containScroll: 'trimSnaps',
    dragThreshold: 5,
    skipSnaps: true,
    slidesToScroll: 1,
    startIndex: 0
  };
  
  const emblaApis = new Map();

  const initOrDestroySlider = (node) => {
    const existingApi = emblaApis.get(node);

    if (existingApi) {
      existingApi.destroy();
      emblaApis.delete(node);
    }

    const newApi = EmblaCarousel(node.querySelector('.embla__viewport'), sliderOptions);

    emblaApis.set(node, newApi);
  };

  emblaNodes.forEach((node) => {
    initOrDestroySlider(node);
  });

  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      emblaNodes.forEach((node) => {
        initOrDestroySlider(node);
      });
    }, 150);
  });
};

document.addEventListener('DOMContentLoaded', () => {  
  setTimeout(() => {
    emblaMobileSlider();
    emblaDesktopGallerySlider();
    emblaMobileGallerySlider();
  }, 150)
});
